import { get, post, put } from '@api/request';

export async function fetchTaxLimitationRuns(
  { appraisalNoticeService },
  authenticationToken,
  { page, pageSize },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/taxlimitation/calculationruns?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchTaxLimitationRun(
  { appraisalNoticeService },
  authenticationToken,
  { runID },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/taxlimitation/calculationrun/${runID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function launchTaxLimitationRun(
  { appraisalNoticeService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/taxlimitation/calculationruns`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchRollCorrOpenGroupsByYear(
  { appraisalService },
  authenticationToken,
  { year },
) {
  const url = `${appraisalService}/appraisal/rollcorrection/${year}/open`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchRollCorrReasons(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/codes?type=Roll%20Correction&name=Reason`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchTaxLimitations(
  { appraisalNoticeService },
  authenticationToken,
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/taxlimitation/verification`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createTaxLimitation(
  { appraisalNoticeService },
  authenticationToken,
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/taxlimitation/verification`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function fetchProposedTaxLimitation(
  { appraisalNoticeService },
  authenticationToken,
  { runID, errorsOnly },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/taxlimitation/verification/${runID}/proposedlimitations?errorsOnly=${errorsOnly}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function applyTaxLimitation(
  { appraisalNoticeService },
  authenticationToken,
  { runID },
) {
  const url = `${appraisalNoticeService}//prodigyappraisalnotices/taxlimitation/verification/${runID}/finalize`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function fetchTaxlimitationCompressRuns(
  { appraisalNoticeService },
  authenticationToken,
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/taxlimitation/compressruns`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createTaxLimitationCompressRuns(
  { appraisalNoticeService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/taxlimitation/compressruns`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchCompressRunProperties(
  { appraisalNoticeService },
  authenticationToken,
  { runID, page = 1, pageSize = 50, calculationError, updateError },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/taxlimitation/compressrun/${runID}/properties?page=${page}&pageSize=${pageSize}&calculationErrorsOnly=${calculationError}&updateErrorsOnly=${updateError}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateTaxLimitationCompressRuns(
  { appraisalNoticeService },
  authenticationToken,
  { payload, runID },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/taxlimitation/compressrun/${runID}/update`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchPropertyYearEditable(
  { appraisalNoticeService },
  authenticationToken,
  { pYear },
) {
  const url = `${appraisalNoticeService}/appraisal/year/${pYear}/iseditable`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchTaxlimitationHITLRuns(
  { appraisalNoticeService },
  authenticationToken,
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/taxlimitation/hitlruns`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createTaxLimitationHITLRun(
  { appraisalNoticeService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/taxlimitation/hitlruns`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchTaxlimitationHITLRunProperties(
  { appraisalNoticeService },
  authenticationToken,
  { runID, calculationErrorsOnly, updateErrorsOnly, page = 1, pageSize = 50 },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/taxlimitation/hitlrun/${runID}/properties?page=${page}&pageSize=${pageSize}&calculationErrorsOnly=${calculationErrorsOnly}&updateErrorsOnly=${updateErrorsOnly}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateTaxLimitationHITLRun(
  { appraisalNoticeService },
  authenticationToken,
  { runID, payload },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/taxlimitation/hitlrun/${runID}/update`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchTaxlimitationExemptionBetaCalculation(
  { appraisalNoticeService },
  authenticationToken,
  { pExemptionID },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/taxlimitation/exemption/${pExemptionID}/calculate`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchSchoolDistrictMCRValidation(
  { appraisalNoticeService },
  authenticationToken,
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/taxlimitation/validateschooldistrictmcr`;
  const { body } = await get(authenticationToken, url);
  return body;
}
